"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopMenuWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TopMenuWrapper = exports.TopMenuWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q7o4i50"
} : {
  target: "e1q7o4i50",
  label: "TopMenuWrapper"
})(props => `
  position: fixed;
  left: ${props.sideBarWidth ? props.sideBarWidth : '0'};
  top: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: ${props.bgcolor};
  height: 60px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  z-index: 10;
  transition: left .2s ease-in-out;
  

  @media screen and (max-width: 768px) {
    padding: 0 1em;
  }
`);